var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": { maxWidth: _vm.getMaxWidth, minWidth: _vm.getMinWidth },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_preview,
        callback: function($$v) {
          _vm.show_preview = $$v
        },
        expression: "show_preview"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_preview = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n\t\t\t\t" + _vm._s(_vm.$t(_vm.game_name)) + "\n\t\t\t"
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding" }, [
            _c("div", { staticClass: "row q-pa-xs justify-center" }, [
              _c("p", { staticClass: "col-12 text-bold" }, [
                _vm._v(_vm._s(_vm.$t("game_preview")))
              ]),
              !_vm.game_finished
                ? _c("div", { staticClass: "row col-12" }, [
                    _vm.max_errors !== null && _vm.max_errors >= 0
                      ? _c("p", { staticClass: "col-12 text-center" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t("errors") +
                                  ": " +
                                  _vm.qty_errors +
                                  " / " +
                                  _vm.max_errors +
                                  " "
                              ) +
                              "\n\t\t\t\t\t"
                          )
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _c(
                "div",
                [
                  _c(
                    "q-carousel",
                    {
                      staticClass: "q-my-sm",
                      attrs: {
                        color: "primary",
                        easing: _vm.overshoot,
                        autoplay: _vm.autoplay,
                        height: "550px"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "control-progress",
                          fn: function(carousel) {
                            return _c(
                              "q-carousel-control",
                              { attrs: { position: "top", offset: [260, 10] } },
                              [
                                _c("q-progress", {
                                  attrs: {
                                    percentage: carousel.percentage,
                                    stripe: "",
                                    color: "primary",
                                    animate: _vm.autoplay
                                  }
                                })
                              ],
                              1
                            )
                          }
                        }
                      ]),
                      model: {
                        value: _vm.slide,
                        callback: function($$v) {
                          _vm.slide = $$v
                        },
                        expression: "slide"
                      }
                    },
                    [
                      _vm._l(_vm.options, function(option, index) {
                        return _c(
                          "q-carousel-slide",
                          {
                            key: index,
                            staticClass: "flex flex-center q-mb-lg bg-gray-1 ",
                            class: _vm.getCardStyle(index)
                          },
                          [
                            _c(
                              "q-card",
                              {
                                staticClass: "card-style q-py-md",
                                attrs: { flat: "" }
                              },
                              [
                                _c(
                                  "q-card-title",
                                  { staticClass: "row q-mx-md" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-overline flex justify-center"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.slide +
                                                1 +
                                                "/" +
                                                _vm.number_of_riddles
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "q-card-main",
                                  _vm._l(option.tips, function(tip, idx) {
                                    return _c(
                                      "div",
                                      {
                                        key: "t" + idx,
                                        staticClass:
                                          "q-body-2 q-my-lg q-mx-md text-weight-regular text-center tip-text"
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(tip.label) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                ),
                                _c(
                                  "q-card-actions",
                                  { attrs: { align: "center" } },
                                  _vm._l(option.alternatives, function(
                                    alt,
                                    altIdx
                                  ) {
                                    return _c(
                                      "q-btn",
                                      {
                                        key: "alt" + altIdx,
                                        class: _vm.getAnswerStyle(
                                          index,
                                          altIdx
                                        ),
                                        attrs: { flat: "" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.selectAnswer(
                                              index,
                                              alt.value
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(alt.label) +
                                            "\n\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      _c(
                        "q-carousel-control",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.slide > 0,
                              expression: "slide > 0"
                            }
                          ],
                          staticClass: "text-white",
                          staticStyle: {
                            padding: "4px",
                            "border-radius": "4px"
                          },
                          attrs: { slot: "control", position: "top-left" },
                          slot: "control"
                        },
                        [
                          _c("q-btn", {
                            attrs: {
                              flat: "",
                              color: "primary",
                              icon: "fas fa-arrow-left",
                              disable: _vm.slide >= _vm.number_of_riddles
                            },
                            on: {
                              click: function($event) {
                                _vm.slide -= 1
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "q-carousel-control",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.slide < _vm.number_of_riddles - 1,
                              expression: "slide < number_of_riddles - 1"
                            }
                          ],
                          staticClass: "text-white",
                          staticStyle: {
                            padding: "4px",
                            "border-radius": "4px"
                          },
                          attrs: { slot: "control", position: "top-right" },
                          slot: "control"
                        },
                        [
                          _c("q-btn", {
                            attrs: {
                              flat: "",
                              color: "primary",
                              icon: "fas fa-arrow-right",
                              disable: _vm.slide >= _vm.number_of_riddles
                            },
                            on: {
                              click: function($event) {
                                _vm.slide += 1
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm.game_finished
                ? _c(
                    "div",
                    { staticClass: "col-10 q-mt-lg" },
                    [
                      _c("p", { staticClass: "text-bold q-mt-sm" }, [
                        _vm._v(_vm._s(_vm.$t("result")))
                      ]),
                      _c("q-slider", {
                        attrs: {
                          disable: "",
                          markers: "",
                          snap: "",
                          color: _vm.game_finished
                            ? _vm.getSliderColor()
                            : "blue-6",
                          min: 0,
                          max: _vm.number_of_riddles
                        },
                        model: {
                          value: _vm.user_score,
                          callback: function($$v) {
                            _vm.user_score = $$v
                          },
                          expression: "user_score"
                        }
                      }),
                      _vm.max_errors >= 0
                        ? _c("p", { staticClass: "q-mt-sm" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t("errors") +
                                    ": " +
                                    _vm.qty_errors +
                                    " / " +
                                    _vm.max_errors
                                ) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        : _vm._e(),
                      _vm.user_won
                        ? _c("p", [_vm._v(_vm._s(_vm.$t(_vm.success_message)))])
                        : _c("p", [_vm._v(_vm._s(_vm.$t(_vm.failure_message)))])
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "col-xs-12 q-mt-md" }, [
              _c(
                "div",
                { staticClass: "row justify-end" },
                [
                  _c("q-btn", {
                    attrs: { color: "secondary", label: _vm.$t("back") },
                    on: {
                      click: function($event) {
                        _vm.show_preview = false
                      }
                    }
                  }),
                  _vm.game_finished
                    ? _c("q-btn", {
                        staticClass: "q-ml-md",
                        attrs: {
                          color: "primary",
                          label: _vm.$t("play_again")
                        },
                        on: { click: _vm.resetGame }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }